// extracted by mini-css-extract-plugin
export default {"root":"MyClients_root__QeeHV","header":"MyClients_header__+4jvu","heading":"MyClients_heading__a46Sb","empty":"MyClients_empty__VGVYH"};